import React from 'react';
import PropTypes from 'prop-types';

import globals from '../../../globals/communityGlobals';

const locale = globals.getArea('accountLogin');

const LandingPage = ({ children }) => {
  const { version, instance } = globals;
  const currentYear = globals.now.year();
  const versionLabel = `${version} ${instance}`;

  return (
    <div className="login">
      <div className="content-wrapper">
        <section>
          <header className="app-header">
            <img
              className="app-logo"
              src="images/branding/Allocate-Solutions-ECommunity.png"
              alt={locale.getMsg('applicationLogo')}
            />
          </header>
          <div className="main-content">
            <div>
              <section className="group group-padding">{children}</section>
            </div>
          </div>
        </section>
      </div>
      <footer>
        <div className="logo-wrap">
          <a href="http://www.allocatesoftware.com/">
            <img src="images/branding/allocate-logo-white.svg" alt={locale.getMsg('allocateLogo')} />
          </a>
        </div>
        <div className="version-info">
          <div>{locale.getMsg('applicationVersion', [versionLabel])}</div>
          <div>{locale.getMsg('rightsReserved', [`${currentYear}`])}</div>
        </div>
      </footer>
    </div>
  );
};

LandingPage.propTypes = {
  children: PropTypes.node.isRequired,
};

export default LandingPage;
